import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { OverquotaPopupProps } from 'reactApp/ui/OverquotaPopup/OverquotaPopup';

export const renderOverquotaBanner = (data: OverquotaPopupProps) =>
    openPopupHelper({
        popupName: popupNames.OVERQUOTA_BANNER,
        data,
    });
